import React, { Component } from 'react';
import App_data from '../../../config/App_data';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import FD from '../../../RestAPI/fetchData';
// import GD from "../../../RestAPI/getData";
import language from '../../../../assets/languages/language';
import SoaFM_SubscriptionCheck from '../../../RestAPI/SoaFMSubscription';
import PartnerSoaFM_SubscriptionCheck from '../../../RestAPI/PartnerSubscription/SoaFMSubscription';
import ModalComponent from '../../../Common/Modal';
import AlertMessage from '../../../config/alertMessage';
import PDFModelComponent from '../../../Common/PDFModel';
// import { getDeviceDetails } from "../../../../common/deviceDetails";
import { getIpAddress } from '../../../../common/getIpAddress';
import { messages } from '../../../../common/messages';
import {autorun} from "mobx";
import userStore from "../../../../store/userStore";
/* eslint-disable*/
class SOA_FM_Notes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alert_status: false,
      PDF_Alert_status: false,
      Active_Alert_status: false,

      MessageTitle: App_data.messageTitle_cfa,
      MessageContent: AlertMessage.messageContent_soa_fm,

      ActiveMessageTitle: `${language.LC().MESSAGE}`,
      ActiveMessageContent: `${language.LC().NOTE_NOT_FOUND}`,

      chapters: [],
      token: '',
      idname: '',
      ValidToken: false,
      chapter_id: '',
      offset: 0,
      limit: 10,
      pdfLoading: true,
      showFreePremium: '',
      showFreePremiumPDF: '',
      selectedmenu: 'soa_fm',
      lastRecord: '',
      lastAttempt: false,
      PDFContentMessage: language.LC().PDFContentMessage,
      type: 'notes',
      user_city: '',
      user_country: '',
      user_ip: '',
      user_state: '',
      user_continent: '',
    };
    this.toggleAlert = this.toggleAlert.bind(this);

    this.ActiveToggleAlert = this.ActiveToggleAlert.bind(this);
    this.PDFDownloadAlertModel = this.PDFDownloadAlertModel.bind(this);
    //this._getReadings = this._getReadings.bind(this);
  }

  static contextTypes = {
    router: React.PropTypes.object,
  };

  toggleAlert() {
    this.setState({
      alert_status: !this.state.alert_status,
    });
  }

  ActiveToggleAlert() {
    this.setState({
      Active_Alert_status: !this.state.Active_Alert_status,
    });
  }

  PDFDownloadAlertModel() {
    this.setState({
      PDF_Alert_status: !this.state.PDF_Alert_status,
    });
  }

  goPremium() {
    this.context.router.push({
      pathname: '/Subscribe/',
      state: {
        token: this.state.token,
        idname: this.state.idname,
        selectedMenu: this.state.selectedmenu,
      },
    });
  }

  _getReadings = async (chapter, e) => {
    var verifyData = {
      token: this.state.token,
      idname: this.state.idname,
      chapter_id: chapter.chapter_no,
    };
    //* Please avoid this code, I have added this code in todo list for optimization
    await FD.callAPI(App_data.backend_api + '/soa_fm_notes/getActiveNotes', verifyData).then(
      async resp => {
        if (resp.success) {
          if (chapter.chapter_no === 1) {
            this.context.router.push({
              pathname: '/soa/financialmathematics/beginnotes/' + chapter.chapter_no,
              state: {
                token: this.state.token,
                idname: this.state.idname,
                chapter: chapter.chapter_no,
              },
            });
          } else {
            var final_exam = [];
            var data = { token: this.state.token, idname: this.state.idname };
            await FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(resp => {
              // console.log("resp", resp);
              if (resp.profileInfo.role === 'partner') {
                if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
                  this.toggleAlert();
                } else {
                  var data_arr = resp.profileInfo.exam_selected
                    ? JSON.parse(resp.profileInfo.exam_selected)
                    : null;
                  var dataset = {
                    token: this.state.token,
                    idname: this.state.idname,
                    examid: data_arr,
                  };
                  FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
                    async resp_exam => {
                      if (resp_exam.success) {
                        var exam_data = resp_exam.examData;
                        var selectedmen = this.state.selectedmenu;
                        var isInArray_var = false;
                        isInArray_var = await PartnerSoaFM_SubscriptionCheck.checkSoaFMNotesSubscription(
                          selectedmen,
                          exam_data,
                        );
                        if (isInArray_var) {
                          this.context.router.push({
                            pathname: '/soa/financialmathematics/beginnotes/' + chapter.chapter_no,
                            state: {
                              token: this.state.token,
                              idname: this.state.idname,
                              chapter: chapter.chapter_no,
                            },
                          });
                        } else {
                          this.toggleAlert();
                        }
                      }
                    },
                  );
                }
              } else {
                if (resp.profileInfo.exam_selected === '') {
                  this.toggleAlert();
                } else {
                  var data_arr = resp.profileInfo.exam_selected
                    ? JSON.parse(resp.profileInfo.exam_selected)
                    : null;
                  var dataset = {
                    token: this.state.token,
                    idname: this.state.idname,
                    examid: data_arr,
                  };
                  FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
                    resp_exam => {
                      // console.log(resp_exam);
                      if (resp_exam.success) {
                        var exam_data = resp_exam.examData;
                        var selectedmen = this.state.selectedmenu;
                        var isInArray_var = false;
                        // console.log(exam_data);
                        // console.log(selectedmen);
                        isInArray_var = SoaFM_SubscriptionCheck.checkSoaFMNotesSubscription(
                          selectedmen,
                          exam_data,
                        );
                        // console.log(isInArray_var);
                        if (isInArray_var) {
                          this.context.router.push({
                            pathname: '/soa/financialmathematics/beginnotes/' + chapter.chapter_no,
                            state: {
                              token: this.state.token,
                              idname: this.state.idname,
                              chapter: chapter.chapter_no,
                            },
                          });
                        } else {
                          this.toggleAlert();
                        }
                      } else {
                        // console.log('fail');
                      }
                    },
                  );
                }
              }
            });
          }
        } else {
          this.ActiveToggleAlert();
        }
      },
    );
  };

  async componentDidMount() {
    window.scrollTo(0, 0);
    // api to get ip address
    const result = await getIpAddress();
    if (result) {
      this.setState({
        user_city: result.city,
        user_country: result.country,
        user_ip: result.query,
        user_state: result.region,
        user_continent: result.continent,
      });
    }
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
    });
    if (localStorage.getItem('selectedmenu') === 'frm') {
      this.context.router.push({
        pathname: '/frm/questionbank/',
        state: {
          token: storage_session['token'],
          idname: storage_session['idname'],
        },
      });
    }

    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
    };
    FD.callAPI(App_data.backend_api + '/soa_fm_notes/getChapters', data).then(async resp => {
      // console.log(resp);
      if (resp.success) {
        this.setState({ ValidToken: true, chapters: resp.chapters });
        var data = { token: this.state.token, idname: this.state.idname };
        FD.callAPI(App_data.backend_api + '/soa_fm_notes/getlastReadNotes', data).then(response => {
          if (response.success) {
            this.setState({
              lastRecord: response.data,
              lastAttempt: true,
            });
          }
        });
      } else {
        this.setState({ ValidToken: false });
      }
      return resp;
    });
    this.dispose = autorun(() => {
      const resp = userStore;

      if(resp == null || resp.profileInfo == null){
        return;
      }
    // await FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(async resp => {
      //console.log("resp getProfile info", resp);

      if (resp.profileInfo.role === 'partner') {
        if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
          this.setState({ showFreePremium: true, showFreePremiumPDF: true });
        } else {
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;

          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            async resp_exam => {
              //console.log(resp_exam);
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                var isInArray_var = false;
                var isInArray_varPDF = false;

                isInArray_var = await PartnerSoaFM_SubscriptionCheck.checkSoaFMNotesSubscription(
                  selectedmen,
                  exam_data,
                );
                if (isInArray_var) {
                  this.setState({ showFreePremium: false });
                } else {
                  this.setState({ showFreePremium: true });
                }
                isInArray_varPDF = await PartnerSoaFM_SubscriptionCheck.checkSoaFM_PDFSubscription(
                  selectedmen,
                  exam_data,
                  this.state.type,
                );
                if (isInArray_varPDF) {
                  this.setState({ showFreePremiumPDF: false });
                } else {
                  this.setState({ showFreePremiumPDF: true });
                }
              } else {
                //console.log("fail");
              }
            },
          );
        }
      } else {
        if (resp.profileInfo.exam_selected === '') {
          this.setState({ showFreePremium: true, showFreePremiumPDF: true });
        } else {
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;

          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            async resp_exam => {
              //console.log(resp_exam);
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                var isInArray_var = false;
                var isInArray_varPDF = false;

                isInArray_var = await SoaFM_SubscriptionCheck.checkSoaFMNotesSubscription(
                  selectedmen,
                  exam_data,
                );
                //console.log(isInArray_var);
                if (isInArray_var) {
                  this.setState({ showFreePremium: false });
                } else {
                  this.setState({ showFreePremium: true });
                }
                isInArray_varPDF = await SoaFM_SubscriptionCheck.checkSoaFM_PDFSubscription(
                  selectedmen,
                  exam_data,
                  this.state.type,
                );
                //console.log(isInArray_varPDF);
                if (isInArray_varPDF) {
                  this.setState({ showFreePremiumPDF: false });
                } else {
                  this.setState({ showFreePremiumPDF: true });
                }
              } else {
                //console.log("fail");
              }
            },
          );
        }
      }
    });
  }

  componentWillUnmount() {
    if(this.dispose) this.dispose();
  }

  /*
----------------------------------
  Notes PDF DOWNLOAD Via email
---------------------------------
*/

  getpdf = async e => {
    if (this.state.pdfLoading === false) {
      alert('Download is in progress....');
      return;
    }
    var data = { token: this.state.token, idname: this.state.idname };
    FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(async resp => {
      if (resp.profileInfo.exam_selected === '') {
        this.toggleAlert();
      } else {
        var data_arr = resp.profileInfo.exam_selected
          ? JSON.parse(resp.profileInfo.exam_selected)
          : null;
        var dataset = {
          token: this.state.token,
          idname: this.state.idname,
          examid: data_arr,
        };
        await FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
          async resp_exam => {
            if (resp_exam.success) {
              var exam_data = resp_exam.examData;
              var selectedmen = this.state.selectedmenu;
              var isInArray_varPDF = false;
              isInArray_varPDF = await SoaFM_SubscriptionCheck.checkSoaFM_PDFSubscription(
                selectedmen,
                exam_data,
                this.state.type,
              );
              if (isInArray_varPDF) {
                this.setState({
                  pdfLoading: false,
                });
                // const result = getDeviceDetails();
                var dataset = {
                  token: this.state.token,
                  idname: this.state.idname,
                  chapterId: this.state.chapterid,
                  city: this.state.user_city,
                  country: this.state.user_country,
                  state: this.state.user_state,
                  continent: this.state.user_continent,
                  ip: this.state.user_ip,
                };
                await FD.callAPI(
                  App_data.backend_api + '/soa_fm_notes/PdfDownloadViaEmail',
                  dataset,
                ).then(response => {
                  if (response.success) {
                    this.setState({
                      pdfLoading: true,
                    });
                    this.PDFDownloadAlertModel();
                  } else if (!response.pdf) {
                    this.setState({
                      pdfLoading: true,
                    });
                    this.PDFDownloadAlertModel();
                  }
                });
              } else {
                this.toggleAlert();
              }
            } else {
              // console.log('fail');
            }
          },
        );
      }
    });
  };

  goToNotes = async () => {
    const { lastRecord, lastAttempt } = this.state;
    if (lastAttempt) {
      this.context.router.push({
        pathname: '/soa/financialmathematics/beginnotes/' + lastRecord.soa_fm_note.chapter_id,
        state: {
          token: this.state.token,
          idname: this.state.idname,
          chapter: lastRecord.soa_fm_note.chapter_id,
        },
      });
    }
  };
  render() {
    let chapters = this.state.chapters;
    let data = '';
    const { lastAttempt } = this.state;
    if (this.state.chapters.length) {
      data = chapters.map(item => (
        <div className='col-md-6 col-lg-6 col-xl-4 question_box free-premium-section' key={item.id}>
          <div
            className='question_bank_wrap pointer_class'
            key={item.id}
            onClick={this._getReadings.bind(this, item)}
          >
            {this.state.showFreePremium ? (
              item.id === 1 ? (
                <div className='tag-tile free'> {language.LC().FREE} </div>
              ) : (
                <div className='tag-tile premium'> {language.LC().PREMIUM} </div>
              )
            ) : null}
            <div className='margin_bottom_30'>
              <img
                src={App_data.frontend_url + '/img/notes/notes_icon1.svg'}
                className=''
                width='40'
                alt=''
              />
            </div>

            <div className='question_title' key={item.id} value={item.id}>
              <a>
                {item.chapter_no} {item.chapter_name}
              </a>
            </div>
            <ul key={item.chapter_name}>
              {item.Countreading}
              <li>
                <span>
                  <img
                    src={App_data.frontend_url + '/img/notes/notes_icon3.svg'}
                    className=''
                    width='20'
                    alt=''
                  />
                </span>
                <span> {item.Countquestion}</span>
                <div className='tootip_box'>{language.LC().TOTAL_NOTES}</div>
              </li>
            </ul>
          </div>
        </div>
      ));
    } else {
      data = (
        <div className='loader_box'>
          <div className='sk-circle'>
            <div className='sk-circle1 sk-child' />
            <div className='sk-circle2 sk-child' />
            <div className='sk-circle3 sk-child' />
            <div className='sk-circle4 sk-child' />
            <div className='sk-circle5 sk-child' />
            <div className='sk-circle6 sk-child' />
            <div className='sk-circle7 sk-child' />
            <div className='sk-circle8 sk-child' />
            <div className='sk-circle9 sk-child' />
            <div className='sk-circle10 sk-child' />
            <div className='sk-circle11 sk-child' />
            <div className='sk-circle12 sk-child' />
          </div>
        </div>
      );
    }
    return (
      <div className='animated fadeIn'>
        <div className='row'>
          <div className='col-sm-2 margin_bottom_20'>
            <h1 className='section_head'>{language.LC().NOTES}</h1>
          </div>
          <div className='col-sm-10 margin_bottom_20 A_FM_notes_title_wrap'>
            <div onClick={this.getpdf.bind(this)} className='status-download-btn mr-1'>
              <a className='btn btn-primary  pointer_class pull-right'>
                {this.state.pdfLoading ? (
                  <i className='fa fa-download' aria-hidden='true' />
                ) : (
                  <i className='fa fa-spinner fa-spin' aria-hidden='true' />
                )}
                {this.state.showFreePremiumPDF ? (
                  <div className='premium-download'>{language.LC().PREMIUM}</div>
                ) : null}

                {this.state.pdfLoading ? language.LC().Download_Notes : '  please wait...'}
              </a>
            </div>
            {lastAttempt && (
              <button
                className='btn btn-primary pointer_class '
                onClick={this.goToNotes}
                disabled={!lastAttempt}
              >
                {messages.GO_TO_MY_LAST_READ_NOTE}
              </button>
            )}
          </div>
        </div>
        <div className='row'>
          <div className='col-12 seperator-block-wrap'>
            <div className='card'>
              <div className='card-block'>
                <div className='card-block'>
                  <div className='row'>{data}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Modal
          isOpen={this.state.Active_Alert_status}
          toggle={this.ActiveToggleAlert}
          className={'modal-primary ' + this.props.className}
        >
          <ModalHeader toggle={this.ActiveToggleAlert}>{this.state.ActiveMessageTitle}</ModalHeader>
          <ModalBody>{this.state.ActiveMessageContent}</ModalBody>
        </Modal>
        <ModalComponent
          goPremium={this.goPremium.bind(this)}
          toggleAlert={this.toggleAlert.bind(this)}
          alert_status={this.state.alert_status}
          MessageContent={this.state.MessageContent}
        />
        <PDFModelComponent
          type={'Study Notes'}
          pdfAlertModel={this.PDFDownloadAlertModel.bind(this)}
          pdfAlert={this.state.PDF_Alert_status}
          PDFContentMessage={this.state.PDFContentMessage}
        />
      </div>
    );
  }
}

export default SOA_FM_Notes;



// WEBPACK FOOTER //
// ./src/views/SOA/FinancialMathematics/Notes/Notes.js